/**
 * workflow-core
 *
 * Copyright (c) Ballerine
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
import { WorkflowDefinitionConfigThemes, WorkflowDefinitionConfigThemeEnum } from '../../consts/index.js';
import { z } from 'zod';

var WorkflowDefinitionConfigThemeSchema = z.object({
  type: z["enum"](WorkflowDefinitionConfigThemes)["default"](WorkflowDefinitionConfigThemeEnum.KYB),
  tabsOverride: z.array(z.string()).optional()
});

export { WorkflowDefinitionConfigThemeSchema };
//# sourceMappingURL=workflow-config-theme.js.map
